import React from 'react'
import { X, FileText } from 'lucide-react'

export interface DocumentPreviewItem {
  fileKey: string
  url: string
  fileName: string
  type: 'image' | 'pdf'
  documentType: string
  uploading?: boolean
}

interface DocumentPreviewCardProps {
  item: DocumentPreviewItem
  onRemove: () => void
}

const DocumentPreviewCard: React.FC<DocumentPreviewCardProps> = ({ item, onRemove }) => {
  const isImage = item.type === 'image'

  return (
    <div className="relative inline-flex flex-col items-center">
      <div className="w-20 h-20 rounded-lg border-2 border-gray-200 bg-gray-50 overflow-hidden flex items-center justify-center group">
        {isImage ? (
          <img
            src={item.url}
            alt={item.fileName}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-gray-500 p-2">
            <FileText className="h-8 w-8" />
            <span className="text-[10px] truncate max-w-full mt-0.5" title={item.fileName}>
              {item.fileName.length > 12 ? `${item.fileName.slice(0, 10)}…` : item.fileName}
            </span>
          </div>
        )}
        {item.uploading && (
          <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-2 border-primary-500 border-t-transparent" />
          </div>
        )}
        <button
          type="button"
          onClick={onRemove}
          disabled={item.uploading}
          className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center shadow-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          aria-label="Remove document"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  )
}

export default DocumentPreviewCard
